import { useState, useEffect, Fragment } from "react";
import FleetWebApi from "../Api/FleetWebApi";
import CircularProgress from "@mui/material/CircularProgress";
import Reports from "./Reports";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import TextField from "@mui/material/TextField";
import OnlineArchiveWarning, {
  isInOnlineArchive,
  useOnlineArchiveConfirm,
} from "./OnlineArchiveWarning";
function ReportSelect(props) {
  const [report, setReport] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reportDate, setReportDate] = useState(new Date());
  const [reportTitle, setReportTitle] = useState(null);
  const [showStatusField, setShowStatusField] = useState(false);
  const [reportTimestamp, setReportTimestamp] = useState(new Date());
  const { confirmDateChange, archiveDialog } = useOnlineArchiveConfirm();
  // Dates older than the archive cutoff only apply after the user confirms the archive query
  const handleDateChange = (date) => {
    confirmDateChange(date, setReportDate);
  };

  useEffect(() => {
    setReportTitle(props.type);
  }, [props.type]);

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);
    setError(null);
    if (reportTitle && reportDate) {
      // Archived dates only get here after the user confirmed the archive prompt
      FleetWebApi.getReportByType(
        reportTitle,
        Math.floor(reportDate.getTime() / 1000),
        isInOnlineArchive(reportDate)
      )
        .then((response) => {
          if (isMounted) {
            setReport(response.data);
            setReportTimestamp(response.timestamp);
            setShowStatusField(response.ShowStatusField);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          if (isMounted) {
            setError(error.message);
            setIsLoading(false);
          }
        });
    }
    return () => {
      // clean the state
      isMounted = false;
    };
  }, [reportTitle, reportDate]);

  return (
    <Fragment>
      <br />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          disableToolbar
          variant="inline"
          format="MM/dd/yyyy"
          margin="normal"
          id="date-picker-inline"
          label="Report Date"
          value={reportDate}
          onChange={handleDateChange}
          KeyboardButtonProps={{
            "aria-label": "change date",
          }}
          renderInput={(params) => <TextField {...params} />}
        />
      </LocalizationProvider>
      <OnlineArchiveWarning date={reportDate} />
      {archiveDialog}

      {error && <p>Error Loading Data: {error}</p>}
      {!error && isLoading && <CircularProgress color="secondary" />}
      {!error && !isLoading && (
        <Reports
          data={report}
          title={reportTitle}
          timestamp={reportTimestamp}
          showStatusField={showStatusField}
          // Click a column name to filter by its values (event spammers report only for now)
          enableColumnFilters={reportTitle === "event-spammers-report"}
          // Spammers report: identify the device and its owner first, then the counts
          leadingColumns={
            reportTitle === "event-spammers-report"
              ? ["coreID", "SerialNumber", "ownerEmail"]
              : undefined
          }
        />
      )}
    </Fragment>
  );
}

export default ReportSelect;
